
// import Vue from "vue";
// Vue.prototype.$server_url = "http://3.23.198.82/";
// let globalVar = {
//   apiUrl: "http://3.23.198.82/api/",
//   server_url: "http://3.23.198.82/",
// };

// export default globalVar;
import Vue from "vue";

function getBaseUrl() {
  const url = window.location.href;
  let baseUrl = new URL(url).origin;
  if (!baseUrl.endsWith("/")) {
    baseUrl += "/";
  }
  return baseUrl;
}

Vue.prototype.$server_url = getBaseUrl();

let globalVar = {
  apiUrl: getBaseUrl() + "api/",
  server_url: getBaseUrl(),
};

export default globalVar;